export default "https://fiverr-res.cloudinary.com/npm-assets/@fiverr/search_perseus/apps/cartoons_comics.3645cbc.svg";